export const backendAssetBase = `${process.env.REACT_APP_BACKEND_URL}/api/static/services`;
const servicesImageVersion = "services-20260321-1";

export const siteMeta = {
  name: "Concept Magik",
  phone: "+1 (201) 286-2097",
  email: "vjo@concept-magik.com",
  logoImage:
    "https://customer-assets.emergentagent.com/job_magik-food-hub/artifacts/o4zixpb0_cmlogo1.jpg",
  headline: "Consulting and design for food service businesses that need clarity, efficiency, and control.",
  subheadline:
    "Concept Magik brings business and design consulting to restaurants, hotels, caterers, institutional kitchens, and hospitality operators with an approach grounded in efficiency, ethics, safety, and client confidentiality.",
  mission:
    "Concept Magik's mission is to conduct business activities using the highest efficient, ethical, and safety standards in the profession.",
  relationship:
    "We strive to develop and maintain lasting relationships with our clients by implementing unique, effective, innovative, timely, and cost-saving solutions.",
  team:
    "Our team consists of highly motivated and dedicated professionals with extensive global experience obtained while working in various components of the multifaceted hospitality industry.",
  philosophy:
    "Client's interest is primary to our business. That philosophy, combined with strict client confidentiality, is the basis of our long-term relationships.",
  heroImage:
    "https://images.pexels.com/photos/5779775/pexels-photo-5779775.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600",
  operationsImage:
    "https://images.pexels.com/photos/7414959/pexels-photo-7414959.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600",
  consultingImage:
    "https://images.unsplash.com/photo-1708915965975-2a950db0e215?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwa2l0Y2hlbiUyMHJlc3RhdXJhbnQlMjBkZXNpZ24lMjBjb25zdWx0aW5nfGVufDB8fHx8MTc3NDAyNDc4N3ww&ixlib=rb-4.1.0&q=85",
  contactImage:
    "https://images.pexels.com/photos/5953503/pexels-photo-5953503.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600",
};

export const homeBadges = [
  "Efficient decision-making",
  "Ethical project standards",
  "Safety-led planning",
  "Strict confidentiality",
];

export const services = [
  {
    slug: "business-consulting",
    title: "Business Consulting",
    summary:
      "Consulting support designed to augment client success with practical thinking around cost, timing, and performance.",
    bullets: [
      "Align business goals with project realities",
      "Evaluate opportunities with a clear operational lens",
      "Support decisions that protect time and budget",
    ],
  },
  {
    slug: "design-consulting",
    title: "Design Consulting",
    summary:
      "Fresh, innovative, and creative thinking tailored to the uniqueness of each food service environment.",
    bullets: [
      "Translate ideas into practical layouts and experiences",
      "Balance workflow, guest experience, and back-of-house needs",
      "Build solutions around each project's specific context",
    ],
  },
  {
    slug: "operational-planning",
    title: "Operational Planning",
    summary:
      "Recommendations informed by hands-on hospitality experience across the multifaceted food service industry.",
    bullets: [
      "Improve operational flow across service environments",
      "Account for staffing, movement, and service pressure",
      "Create plans that support day-to-day execution",
    ],
  },
  {
    slug: "quality-time-cost",
    title: "Quality, Time, and Cost Discipline",
    summary:
      "Every project is approached with a clear focus on quality outcomes, delivery timelines, and cost constraints.",
    bullets: [
      "Identify priority constraints early",
      "Reduce friction with better planning",
      "Keep the project grounded in measurable decisions",
    ],
  },
];

export const industries = [
  {
    slug: "restaurants",
    title: "Restaurants & Cafés",
    description:
      "Sharpen the balance between guest experience, kitchen efficiency, and service speed.",
  },
  {
    slug: "hotels",
    title: "Hotels & Banquet Operations",
    description:
      "Support complex hospitality environments where scale, coordination, and consistency matter.",
  },
  {
    slug: "catering",
    title: "Catering & Cloud Kitchens",
    description:
      "Create systems and spaces that help high-volume production stay disciplined and responsive.",
  },
  {
    slug: "institutional",
    title: "Institutional & Large Kitchens",
    description:
      "Plan around workflow, safety expectations, and dependable throughput for demanding operations.",
  },
  {
    slug: "distributors",
    title: "Food Businesses & Distributors",
    description:
      "Bring structure to facilities and business decisions that affect long-term operational efficiency.",
  },
  {
    slug: "specialty",
    title: "Specialty Hospitality Venues",
    description:
      "Adapt to unique formats with fresh thinking that respects concept, audience, and logistics.",
  },
];

export const principles = [
  {
    slug: "client-success",
    title: "Client Success First",
    description:
      "Our commitment is to provide business and design consulting services that augment each client's success.",
  },
  {
    slug: "fresh-solutions",
    title: "Fresh Solutions",
    description:
      "We understand the uniqueness of each project and approach it with fresh, innovative, and creative solutions.",
  },
  {
    slug: "constraints",
    title: "Disciplined Delivery",
    description:
      "We believe every project must meet quality, time, and cost constraints without losing sight of the bigger goal.",
  },
  {
    slug: "confidentiality",
    title: "Confidential and Trusted",
    description:
      "Strict client confidentiality is built into the way we work and maintain long-term relationships.",
  },
];

export const processSteps = [
  {
    slug: "understand",
    title: "Understand the operation",
    description:
      "Start with the specific business, service environment, and goals behind the project.",
  },
  {
    slug: "shape",
    title: "Shape the right solution",
    description:
      "Develop a focused recommendation with business and design thinking working together.",
  },
  {
    slug: "protect",
    title: "Protect outcomes",
    description:
      "Keep decisions aligned to quality, timing, cost discipline, and long-term usability.",
  },
];

export const navigationItems = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/clients", label: "Clients" },
  { to: "/industries", label: "Industries" },
  { to: "/who-we-are", label: "Who We Are" },
  { to: "/contact", label: "Contact" },
];

export const servicesPageIntro = [
  "CM works pro-actively with each client to define, conceptualize and assist in the orchestration of a responsive program.",
  "We conduct in-depth research to determine perceived and real needs, review operation policies for optimum client and customer benefits, and document our findings in an understandable format.",
  "CM understands and believes that a great experience is mirrored not only in ambiance but is also reflected in the quality service and amenities.",
  "We listen to our clients and make positive change suggestions, reflecting new ideas, new approaches, and the latest in industry technology and operating techniques.",
];

export const servicesPageSections = [
  {
    slug: "concept-development",
    title: "Concept Development",
    description:
      "Successful ventures do not happen in a vacuum or by accident. Major endeavors are pulled together during early initiation stages through concept development and feasibility planning.",
    image: `${backendAssetBase}/istock_000016031648small.jpg?v=${servicesImageVersion}`,
    listLead: "CM works with clients during this stage to develop:",
    items: [
      "Background & Needs",
      "Commercial Viability",
      "Concept & Operational Goals",
      "Ideate",
      "Preliminary Sketches",
      "Cost Estimations",
    ],
  },
  {
    slug: "feasibility-strategy",
    title: "Feasibility & Strategy",
    description:
      "Foodservice projects without a sound plan and strategy can become costly and time consuming",
    image: `${backendAssetBase}/istock_000026784565small.jpg?v=${servicesImageVersion}`,
    listLead:
      "We work with our client and their team to develop a plan that ensures smooth transition for long term success through:",
    items: [
      "Long Term Planning & Strategies",
      "Commercial & Operational Feasibility",
      "Customer Survey & Research",
      "Business & Operational Planning",
      "Space Planning",
      "Staffing Matrices",
      "Cost Benefit Analysis",
    ],
  },
  {
    slug: "design-process",
    title: "Design Process",
    description:
      "CM is proud of its unique position and experience, helping every client in the coordination of the design process from start to finish in a flawless manner.",
    image: `${backendAssetBase}/istock_000015705903small.jpg?v=${servicesImageVersion}`,
    listLead: "We offer the following services during this stage:",
    items: [
      "Review and Report on Existing Conditions",
      "Conceptual Drawings",
      "Schematic Plan",
      "Space Allocation & Work Flow Diagrams",
      "Cost Estimates",
      "Utility Estimates",
      "Design Development",
      "Contract Document",
      "Bidding & Contract Negotiation Reports",
      "Services during Construction Management",
    ],
  },
  {
    slug: "business-advisory-services",
    title: "Business Advisory Services",
    description:
      "Many times, a business’s success rests on choosing the right operating management company, or implementing a proper operation plan with a vision for achievement and growth.",
    image: `${backendAssetBase}/istock_000036808040small.jpg?v=${servicesImageVersion}`,
    listLead: "In this segment we offer the following services to our clients:",
    items: [
      "Program Development",
      "Operator Selection",
      "Request for Proposal (RFP)",
      "Contract Negotiation",
      "Operation Analysis",
      "Operation Audits",
      "Market Surveys",
      "Contract Compliance Evaluations",
    ],
  },
  {
    slug: "additional-services",
    title: "Additional Services",
    description: "CM offers the following services to clients upon request:",
    image: null,
    listLead: null,
    items: [
      "Peer Reviews",
      "Training Programs",
      "Menu Development & Maintenance",
      "Liaison with Health Department",
      "LEED Evaluation and Documentation",
      "Value Engineering",
    ],
  },
];

export const whoWeAreIntro = [
  "Our team consists of highly inspiring and devoted professionals with years of extensive global experience.",
  "We listen to our clients and make suggestions, we challenge them with new ideas, new approaches and inform them of the latest in industry technology and operating techniques. Our success reflects logic and intellect required to complete simple and complex concepts both nationally and internationally.",
];

export const whoWeAreProfiles = [
  {
    slug: "vijay-oza",
    title: "Vijay K. Oza. (VJ) Director of Design",
    image: "https://customer-assets.emergentagent.com/job_magik-food-hub/artifacts/2o56qf77_Vijay%20Oza.jpg",
    paragraphs: [
      "Vijay has a master’s degree in Hospitality Management and is a professional member of FCSI and PMI. His exposure working with hospitality professionals is extensive and global.",
      "Vijay’s involvement at an early age in institutional catering and restaurant operations led to his successes as a leading manufacturer and supplier of commercial kitchen equipment and later as a foodservice consultant in India and other parts of the Asian sub-continent.",
      "Prior to becoming Director of Design with Concept Magic LLC, Vijay was Regional Director at Advanced Foodservice Solutions, and Project Manager at FoodStrategy Inc. and Cini Little International. While employed with these illustrious firms Vijay successfully managed foodservice design projects touching all segments of the industry including hotels, corporate cafeterias, country clubs, religious establishments, hospital and nursing home, schools and college dining facilities.",
    ],
  },
  {
    slug: "peter-dimicelli",
    title: "Peter DiMicelli Jr. Regional Director of Projects - USA",
    image: "https://customer-assets.emergentagent.com/job_magik-food-hub/artifacts/5nvj50uv_Peter%20Dimicelli.jpg",
    paragraphs: [
      "Peter DiMicelli, Jr. Ph.D., MCFE, CHM, CPFM, CEC has spent over 35 years, applying his knowledge and skills in hotels and restaurants throughout the United States, Japan and Europe.",
      "Dr. DiMicelli has also applied his expertise in wholesale and retail food operations. As a professor of hospitality and culinary arts, he teaches courses in food service management, hospitality facilities layout and design, food sanitation and safety, and other related courses. Subsequent to his achievement as owner/operator of a successful catering company in Southern California, Chef DiMicelli has used his knowledge and skills as a national consultant to food brokers and manufacturers for product research and development as well as equipment, food and product demonstrations.",
      "He has also participated in the planning and execution of various retail and wholesale food operation grand openings. Additionally, Chef DiMicelli was the Director of Culinary & Hospitality training for the United States Marine Corps based in Okinawa, Japan, and was the Executive Training Chef at Oklahoma State University.",
    ],
  },
  {
    slug: "nitin-tandon",
    title: "Chef Nitin Tandon. Regional Director Projects - Asia",
    image: "https://customer-assets.emergentagent.com/job_magik-food-hub/artifacts/kqy08mci_Nitin%20Tandon.jpg",
    paragraphs: [
      "Chef Nitin Tandon was voted one of the top 50 Master Chefs in India by the Indian Culinary Forum in 2012. Nitin is a veteran of the food service industry for the past 25 years during which he has worked as Executive Chef, Restaurateur, Food Stylist, TV Chef and Foodservice Consultant.",
      "He started his career as a chef with Taj Group of Hotels and Oberoi Hotels and later as a Restaurateur; he founded dessert store Melting Moments followed by cafes Lemon Grass, Pot Pourri and Seijo.",
      "During his spare time he works as a TV Chef hosting the FoodFood Channel (India).",
      "As Master Food Stylist he has successfully completed several food styling assignments for food industry giants like Nestle, Kissan, Godrej, Amul, Bertolli Oil, McDonalds, Cadbury, and many others.",
    ],
  },
  {
    slug: "sudish-pande",
    title: "Chef Sudish Pande. Project Consultant",
    image: "https://customer-assets.emergentagent.com/job_magik-food-hub/artifacts/1sfy4rxj_Sudish%20Pande.jpg",
    paragraphs: [
      "Sudish Pande has well over 40 years of global experience working as a Culinarian, Executive Chef, Corporate Chef, Production Manager & Consultant in the Hospitality Industry.",
      "Chef Pande as he is popularly known graduated from premier Hospitality School in Bombay, India and has been an Executive Chef to a host of International Star Hotels & International Flight Catering Units in India, USA, Saudi Arabia, Philippines and Hong-Kong. He was involved in initial planning and later conducting day to day operations as a Production Manager at the state of art kitchen for Sri Lankan Catering; which has brought him national recognition and several accolades.",
      "Chef Pande is well known for his research work in developing specialty restaurants and Menu Design and Development.",
    ],
  },
];
